import {Component,Input } from "@angular/core";

@Component({
    selector: 'rx-tab-content',
    template: '<ng-template></ng-template>'
})
export class RxTabContentComponent {
    @Input() class:string;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/view/tab/rx_tab_content_control_component.ts